import { alertStatusOptions, contractorAlertTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfAlert } from "components/table/columnComponents/StatusOfAlert"

export const customerDashboardAlertsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    size: "mini",
    name: "checkbox",
    type: "checkbox",
    cellComponent: "checkbox",
  },
  {
    title: "Alerts",
    type: "select",
    name: "type",
    size: "middle",
    options: contractorAlertTypeOptions,
  },
  {
    title: "Date",
    type: "sort-date-range",
    size: "middle",
    name: "date",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    size: "middle",
    options: alertStatusOptions,
    cellComponent: StatusOfAlert,
  },
]
